import { render, staticRenderFns } from "./freightRate.vue?vue&type=template&id=c0346446&scoped=true"
import script from "./freightRate.vue?vue&type=script&lang=js"
export * from "./freightRate.vue?vue&type=script&lang=js"
import style0 from "./freightRate.vue?vue&type=style&index=0&id=c0346446&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0346446",
  null
  
)

export default component.exports